import { useState } from "react";
import { motion } from "framer-motion";
import { MiniCard } from "@/components/PlayerChip";
import { Pitch } from "@/components/Pitch";
import { useAuth } from "@/context/AuthContext";

const Count = ({ team, n, target }) => (
  <div data-testid={`draft-count-${team}`} className={`flex-1 rounded-2xl py-2 text-center font-display font-black text-sm ${team === "white" ? "bg-white text-zinc-950 border border-slate-300" : "bg-zinc-950 text-white"}`}>
    {team === "white" ? "BLANC" : "NOIR"} {n} / {target}
  </div>
);

export const DraftBoard = ({ data, act, onDone, onTap }) => {
  const { user } = useAuth();
  const [sel, setSel] = useState(null);
  const { draft, match: m } = data;
  const confirmed = data.players.filter((p) => p.registration_status === "confirmed");
  const available = confirmed.filter((p) => !p.team);
  const team = (t) => confirmed.filter((p) => p.team === t);
  const canPick = draft.turn && (user.role === "admin" || m[`captain_${draft.turn}`] === user.id);

  const pick = async () => {
    const r = await act("post", "/draft/pick", { user_id: sel });
    setSel(null);
    if (r?.draft.complete) onDone?.();
  };

  if (!draft.started && !draft.complete) {
    return (
      <div data-testid="draft-not-started" className="rounded-3xl bg-white border border-slate-200 shadow-sm p-6 text-center">
        <p className="font-display font-bold text-lg">Le draft n'a pas encore commencé</p>
        <p className="text-sm text-slate-500 mt-1">Nommez les deux capitaines (onglet Joueurs) : le draft démarre automatiquement.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {draft.turn ? (
        <motion.div key={draft.turn} initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} data-testid="draft-turn"
          className={`rounded-3xl py-4 text-center font-display font-black tracking-wide ${draft.turn === "white" ? "bg-white text-zinc-950 border-2 border-slate-300 shadow-sm" : "bg-zinc-950 text-white border-2 border-cyan-400"}`}>
          AU TOUR DU CAPITAINE {draft.turn === "white" ? "BLANC" : "NOIR"}
        </motion.div>
      ) : (
        <div data-testid="draft-complete" className="rounded-3xl py-4 text-center font-display font-black bg-cyan-400 text-zinc-950">DRAFT TERMINÉ</div>
      )}
      <div className="flex gap-2">
        <Count team="white" n={team("white").length} target={draft.targets.white} />
        <Count team="black" n={team("black").length} target={draft.targets.black} />
      </div>
      <Pitch data={data} onTap={onTap} maxH={58} />
      {available.length > 0 && (
        <>
          <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">Joueurs disponibles ({available.length})</p>
          <div className="grid grid-cols-3 gap-2 pb-20">
            {available.map((p) => (
              <MiniCard key={p.id} p={p} testid={`draft-player-${p.id}`} selected={sel === p.id} onClick={() => canPick && setSel(sel === p.id ? null : p.id)} />
            ))}
          </div>
        </>
      )}
      {canPick && (
        <div className="fixed bottom-20 inset-x-0 mx-auto max-w-md px-4 z-30">
          <button data-testid="draft-select-button" disabled={!sel} onClick={pick}
            className="w-full rounded-2xl bg-cyan-400 text-zinc-950 font-display font-black py-4 shadow-xl shadow-cyan-500/20 active:scale-[0.98] transition disabled:opacity-40">
            SÉLECTIONNER
          </button>
        </div>
      )}
    </div>
  );
};
